import { render, staticRenderFns } from "./IpReMem.vue?vue&type=template&id=7c48742e&"
import script from "./IpReMem.vue?vue&type=script&lang=js&"
export * from "./IpReMem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports